enum ButtonTypeEnum {
  Default = 0,
  Outline = 1,
  Highlight = 2,
  Icon = 3,
  White = 4,
}

export default ButtonTypeEnum
